// extracted by mini-css-extract-plugin
export var container = "_sm-0";
export var inputWidth = "_sm-1";